import { Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import type { GetPcapPlayerFilesQuery, PlayPcapsMutationVariables } from '@uigy/generated/graphql';
import { PcapPlaySpeedEnum } from '@uigy/modules/settings/modules/pcap-player/enums/play-pcap-speed.enum';
import { GenericSliderPage } from '@uigy/shared/components/slider-v2/models/generic-slider-page';
import { ToasterType } from '@uigy/shared/components/toaster/enums/toaster-type.enum';
import { MenuItem } from '@uigy/shared/models/interfaces';
import { LanguageService } from '@uigy/shared/services/language.service';
import Utils from '@uigy/utils';

interface DDSpeedOption {
  name: string;
  value: string;
}

@Component({
    selector: 'app-upload-pcap-form',
    templateUrl: './play-pcap-form.component.html',
    standalone: false
})
export class PlayPcapFormComponent implements GenericSliderPage<GetPcapPlayerFilesQuery, PlayPcapsMutationVariables> {
  public readonly WARNING_TOASTER = ToasterType.Warning;
  public text = this.languageService.texts;
  public form = this.fb.group({
    ids: [],
    speed: []
  });
  public speedDropdownData: MenuItem[] = this.getDropDownItems();

  constructor(private fb: UntypedFormBuilder, private languageService: LanguageService) {
  }

  public getDropDownItems(): MenuItem[] {
    return Object.entries(PcapPlaySpeedEnum)
      .filter((value): value is [string, string] => !!value && value[0].includes('x'))
      .map(([key, value]: [string, string]) => ({value, label: key}));
  }

  public getData(): PlayPcapsMutationVariables {
    return this.form.value;
  }

  public initData(data?: GetPcapPlayerFilesQuery): void {
    if (data) {
      const {id} = Utils.stripConnection(data.pcapPlayer.files)[0];
      this.form.patchValue({ids: [id]});
    }
  }

  public isValid(): boolean {
    return this.form.valid;
  }
}
